import { render, staticRenderFns } from "./VLTable.vue?vue&type=template&id=6583347e&scoped=true&"
import script from "./VLTable.vue?vue&type=script&lang=js&"
export * from "./VLTable.vue?vue&type=script&lang=js&"
import style0 from "./VLTable.vue?vue&type=style&index=0&id=6583347e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6583347e",
  null
  
)

export default component.exports